
import common from "../../api/common";
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import value2name from 'vux/src/filters/value2name.js'

export default {
data() {
return {
demo1: '',
demo2: '',
demo3: '',
demo4: false,
demo5: false,
demo6: false,
demoDe1: false,
demoDe2: false,
demoDe3: false,
daiName:"请选择",
commonList:common,
medicineColumns: [{values: [{name: '代煎',price: 10},{name: '不代煎',price: 0.5} ]}],
discountColumns:[{values: [{name: '优惠',price: 10},{name: '无',price: 0.5} ]}],
discount:{name: '优惠',price: 10},
pickDiscount:false,
medicine: {name: '请选择',price: 10},
PickerShow:false,
patientid: this.$store.state.userInfo.id,//患者id
doctorId: this.$store.state.AllOfValue.doctorId =this.$store.state.AllOfValue.doctorId==null?this.$route.query.doctorId:this.$store.state.AllOfValue.doctorId,
orederId: this.$route.query.id,//订单id
orderCode: '',//订单编号
openid: this.$store.state.userInfo.openid,
state: '',
lasttime: '',//倒计时时
hours: '',//倒计时分
minutes: '',//倒计时秒
doctor: {},//医生信息
patient: {},//患者信息
orderinfo: {},//药方订单信息
checked: true,
address: [],//地址列表
addressLen: '',//地址总数
addressId: this.$route.query.addressId?this.$route.query.addressId:'',
addressItem:{},
isAddress: false,
isSubmit: true,
befrom: this.$route.query.befrom || '',
showIndex: 999,
resultBuyTime: '',
resultTime: '',

overname: '',
overaddress: '',

isSelect: this.$route.query.isSelect || false,
couponId: this.$route.query.couponId || '',
couponSum: this.$route.query.couponSum || '',
quantity: '',//药方数量ordermedicines
declare: '',//煎药说明
medicinalDetails: [],//药方详情
addressOver: {},//交易关闭状态下默认地址
colortext:'',
goodsType:1,

daijian: "1",//是否代煎
selfMention:{},
selfTime:"",
paystateTime:"",


addressType:'',//是否选择了地址
isDelivery: this.$route.query.isDelivery,
isConfirm: false,
prescription: [],
handleState:'', //是否作废或撤回  1撤回 2作废
isMiniProgram:false,
}
},

methods: {
confirmDiscount(picker){
this.discount=picker.currentValue[0];
},
cancelYao(){
this.PickerShow=false;
},

confirmYao(picker){
this.medicine=picker.currentValue.length>0?picker.currentValue[0]:{name:"代煎",price:18};
this.$store.state.medicine = this.medicine;
},
getaddressEdit(){
this.$router.push({path: '/addressedit'});
},

time(servicetime,buytime){
let newtime = servicetime * 60 * 60 * 1000 + buytime;
let oldtime = new Date();
this.lasttime = newtime - oldtime.getTime();
this.hours = parseInt((this.lasttime / (1000 * 60 * 60)));
this.minutes = parseInt((parseFloat(this.lasttime / (1000 * 60 * 60)) - parseInt(this.lasttime / (1000 * 60 * 60))) * 60);
},

onSwipeLeft(i){
this.showIndex = i;
},
onSwiperight(i){
this.showIndex = 999;
},

getAddress(){
let params = {
patientid: this.patientid
};
let that=this;
this.addressList='';
this.$doRequest("/api/patientaddressinfo/getListByKey", params, res=>{
that.address = res;
if(res.length > 0){
this.isAddress = true;

this.addressType = 2;

let _this=this;
if(_this.$store.state.addressList.id==undefined){
for(var i=0;i<res.length;i++){
if(res[i].isdefault==1){
_this.addressItem=res[i];
_this.addressId=res[i].id;
}else {
_this.addressItem = res[0];
_this.addressId=res[0].id;
}
}
}else{
_this.addressItem = _this.$store.state.addressList;
_this.addressId=_this.$route.query.addressId;
}

}

});
},

addAddress(index){






if(index==1){
this.$router.push({path: '/address',query: {orederId: this.orederId}});
}else{
this.$router.push({path: '/addressedit',query: {orederId: this.orederId}});
}
},

upAddress(item){
this.$router.push({path: '/address',query:{id: item.id,receiver: item.receiver,telephone: item.telephone,province: item.province,city: item.city,county: item.county,address: item.address}});
},

removeAddress(id){
this.$doRequest("/api/patientaddressinfo/delete", [id], res=>{
if(res.res != -1){
this.$toastMsg('收货地址删除成功');
this.showIndex = 999;
this.$router.push({path: '/sx'});
}
});
},

defaultAddress(){
let params = {
patientid: this.patientid,
addressid: this.addressList
}
this.$doRequest("/api/Personal/setDefaultAddress", params, res=>{

});
},


goCoupon(state){
if(state == 1){
this.$store.state.sun.pd = 1;
this.$router.push({path: '/myCoupon',query:{orderId: this.orederId,fromType: 'myOrderDetailsYF',type: this.befrom}});
}
},

getCoupon(){
this.$doRequest("/api/PlacingOrder/getMypreferentialPrice", { parameters: this.patientid }).then(res => {
if(res.result == 0){
let list = [];
res.parameters.forEach(function (item) {
if(item.state == 2 && item.invalidity == 1){
list.push(item);
}
});
if(list != '' ){
this.couponId = list[0].id || '';
this.couponSum = list[0].price || '';
}

}
})
},

getOrderDetails(islook){
if(islook==null){
islook=true;
}
let params = islook?{
/*是否获取医生详情信息 1 获取2 不获取*/
getDoctor: '1',
/*是否获取患者详情信息 1 获取2 不获取*/
getPatient: '1',
/*是否获取主诉  1 获取2 不获取*/
isaction: '1',
/*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
getPrescriptionOrder: '1',
/*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
prescriptionOrderId: this.orederId,
}:{
/*是否获取此订单的药方订单详细信息 1 获取2 不获取*/
getPrescriptionOrder: '1',
/*药方订单id，如果想获取问诊订单下面的所有药方订单，此处可不传*/
prescriptionOrderId: this.orederId,
}

this.$doRequest("/api/Inquiry/orderDetails", params, res=>{
if(islook){
this.$store.state.orderAddress = res.orderprescriptioninfos[0].orderid||'';
this.doctor = res.doctor;
this.patient = res.patient;
this.orderinfo = res.orderprescriptioninfos[0];
this.handleState = res.orderprescriptioninfos[0].handleState;
if(this.$store.state.inquirypeople == ''){
this.$store.state.inquirypeople={
name:this.orderinfo.patientname,
id:this.orderinfo.patientId,
}
}
this.prescription = res.orderprescriptioninfos[0].reOrderprescriptioninfo;
for(let i=0;i<this.prescription.length;i++){
if(
this.prescription[i].prescriptionshape =='颗粒'
){
this.prescription[i].generationfry='false'
}else{
this.prescription[i].generationfry=this.prescription[i].generationfry==null?'':this.prescription[i].generationfry==1?"false":this.prescription[i].generationfry==2?"true":"";
}
}
if(this.orderinfo.paystate==2 || this.orderinfo.orderstate==4){
this.delivery(2);
}

this.quantity = this.orderinfo.reOrderprescriptioninfo.length;

let _this = this;
_this.medicinalDetails = [];
this.orderinfo.reOrderprescriptioninfo.forEach(function (item) {
_this.medicinalDetails.push(item.medicinename+' '+item.dosage+item.medicineunit);
if(item.decoctionid != null && item.decoctionname != null){
_this.declare += item.medicinename + '('+ item.decoctionname +')     ';
}
});
if (this.orderinfo.paystate == 1 && this.orderinfo.orderstate != 4) {
this.time(this.orderinfo.servicetime,this.orderinfo.buytime);
};
this.orderCode = this.orderinfo.orderid;
this.resultBuyTime = common.timestampToTime(this.orderinfo.buytime,1);
this.resultTime = common.timestampToTime(this.orderinfo.paytime);


if(this.orderinfo.paystate != 1){
let eq = this.orderinfo.address.indexOf('$');
let total = this.orderinfo.address.length;
this.overaddress = this.orderinfo.address.substring(0,eq);
this.overname = this.orderinfo.address.substring(eq+1,total);
}

if(this.orderinfo.paystate == 4){
let eq = this.orderinfo.address.indexOf('$');
let total = this.orderinfo.address.length;
this.overaddress = this.orderinfo.address.substring(0,eq);
this.overname = this.orderinfo.address.substring(eq+1,total);
}

if(this.$store.state.medicine){
this.medicine = this.$store.state.medicine;
}
if(this.isSelect){

this.couponId = this.$route.query.couponId;
this.couponSum = this.$route.query.couponSum;
}else{
if(this.orderinfo.orderstate == 1){
this.getCoupon();
}else if(this.orderinfo.orderstate == 2){
if(this.orderinfo.saletype == 2){
this.couponId = this.orderinfo.couponid;
this.couponSum = this.orderinfo.saleprice;
}
}
}
}
})
},

goConfirm(val){
if(this.isDelivery == 0 || !this.isDelivery){
this.$toastMsg('请选择配送方式');
return;
}else{
for(var i=0;i<this.prescription.length;i++){
if(this.prescription[i].generationfry==''){
this.$toastMsg('请选择药方'+(i+1)+'是否代煎');
return;
}
}
if(this.isDelivery == 1 && (!this.addressItem || Object.keys(this.addressItem).length == 0)){
this.isSubmit = true;
this.$toastMsg('请选择收货地址');
return;
}else{
if(this.orderinfo.prescriptionshape == '饮片' && this.orderinfo.generationfry == 3 && (this.medicine.name == '请选择' || this.medicine.name == undefined)){
this.$toastMsg('请选择代煎方式');
return;
}else{
this.isConfirm = val;
}
}
}
},

paySubmit(){
if(this.isSubmit){
this.isSubmit = false;
let _this = this;
if(_this.orderinfo.prescriptionshape=='颗粒'){
_this.daijian="1";
}/*else if(_this.orderinfo.yfgenerationfry==2){
_this.daijian="2";
}*/else if(_this.orderinfo.generationfry!=3){
_this.daijian=_this.orderinfo.generationfry+'';
}else{
_this.daijian=_this.medicine.name=="不代煎"?"1":_this.medicine.name=="代煎"?"2":"";
}
let decoctionren=_this.orderinfo.generationfry==1||_this.orderinfo.generationfry==2?"1":"2";
if(_this.daijian=="1"||_this.daijian=="2"||_this.daijian=="undefined"){
let dj='';
let djr='';
for(let i=0;i<_this.prescription.length;i++){
dj +=  _this.prescription[i].id + "@" + (_this.prescription[i].generationfry=="true"?"2":"1")+ "," ;
djr += _this.prescription[i].id + "@" + (_this.prescription[i].generationfry=='false'?"1":"2")+ "," ;

}
if (dj.length > 0) {
dj = dj.substr(0, dj.length - 1);
}
if (djr.length > 0) {
djr = djr.substr(0, djr.length - 1);
}












if(_this.orderinfo.paystate==2 || _this.orderinfo.orderstate==4){
this.delivery(2);
}
if(_this.handleState==1){
_this.$toastMsg("该订单已撤回，请勿支付");
return;
}
if(_this.handleState==2){
_this.$toastMsg("该订单已作废，请勿支付");
return;
}
var openid="";
if(_this.isMiniProgram === true){
openid=this.$store.state.userInfo.miniopenid
}else{
openid=this.$store.state.userInfo.patientcode
}
_this.$doRequest("/api/weixinpay/sendWeiPayRequest?ordercode="+ this.orderCode +"&kfc="+ this.couponId +"&addressId="+ this.addressId +"&openid="+openid+"&yfdj="+ dj +"&sendtype="+ _this.goodsType +"&decoctionren="+djr+"&inquiryId="+_this.$store.state.inquirypeople.id,null,res => {
try {

if(res.return_code=="SUCCESS"){

if(res.totalfee*1>0){

if (_this.isMiniProgram === true) {


const payParam = res.weiAppLetEntity;
_this.navigateToMiniProgram(JSON.stringify(payParam));
}
else{
WeixinJSBridge.invoke('getBrandWCPayRequest', res.weiAppLetEntity,function(res){

_this.isSubmit = true;
if(res.err_msg=='get_brand_wcpay_request:ok'){
_this.isConfirm = false;

if((_this.befrom && _this.befrom == 'orderList')||(_this.$route.query.ptid!=null&&_this.$route.query.ptid!='')){
_this.$router.push({path: '/sx'});
}else{
_this.getOrderDetails(false);
common.unLock(_this, "todoctorLock" + _this.docid)
_this.$router.push({path: '/physicianVisits?doctorId=' + _this.doctorId});
}
}else{
if(res.err_msg=='get_brand_wcpay_request:fail'){
_this.$toastMsg("支付失败");
}
_this.$router.push({path: '/sx'});
}
});
}




}else{
_this.isSubmit = true;

if((_this.befrom && _this.befrom == 'orderList')||(_this.$route.query.ptid!=null&&_this.$route.query.ptid!='')){
_this.$router.push({path: '/sx'});
}else{
_this.getOrderDetails(false);
common.unLock(_this, "todoctorLock" + _this.docid)
_this.$router.push({path: '/physicianVisits?doctorId=' + _this.doctorId});
}
}
}else{
_this.isSubmit = true;
_this.$toastMsg(res.return_msg);
}
}catch (e) {
_this.$toastMsg(e);
_this.isSubmit = true;
}
},
err =>{
_this.isSubmit = true;
});
}else{
_this.$toastMsg("请选择代煎");
_this.isSubmit=true;
}

}
},
delivery(index){
if(index == 1){
this.isDelivery = 1;
}else{
this.isDelivery = 2;
this.goodsType=index;
let _this=this;
let dateTime=new Date();
let params={
receiver: '北京好中医潘家园医馆'
}
this.$doRequest("/api/patientaddressinfo/getListByKey",params ,res=>{
let hfmTime=common.timestampToTime(_this.orderinfo.paytime,3);
let dateTime=new Date();
let payTime=common.timestampToTime(dateTime,3);
if(_this.orderinfo.paystate == 2){

if(_this.orderinfo.generationfry=="2"){
_this.paystateTime=hfmTime<"12:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.orderinfo.generationfry=="1"){
_this.paystateTime=hfmTime<"15:00:00"?common.timestampToTime(new Date(),9):_this.paystateTime=common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}
}else if(_this.orderinfo.paystate == 1 && _this.orderinfo.orderstate != 4){

if(_this.orderinfo.generationfry=="2"){
_this.selfTime=payTime<"12:00:00"?common.timestampToTime(new Date(),9): _this.selfTime=common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.orderinfo.generationfry=="1"){
_this.selfTime=payTime<"15:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else if(_this.medicine.name=="代煎"){
_this.selfTime=payTime<"12:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}else{
_this.selfTime=payTime<"15:00:00"?common.timestampToTime(new Date(),9):common.timestampToTime(dateTime.setDate(dateTime.getDate()+1),9);
}
}

_this.selfMention={
"receiver": '北京好中医潘家园医馆',

"telephone": '15010171818',
"province": '北京市',
"city": '北京市',
"county": '朝阳区',
"address": '潘家园路9号院28号楼底商'
}
})
}
},

gotoinquiry(){
this.$router.push({path:'/inquirypeople',query:{selectType: '2',orderId: this.orederId,befrom:this.$route.query.befrom,paidTypes:this.$route.query.paidTypes}});
},
init(){
if(this.$store.state.userInfo.telephone == null || this.$store.state.userInfo.telephone == ''){
this.$toastMsg('请完善手机号');
this.$router.push({path: '/boundPhone', query:{form:'myOrderDetailsYF'}});
}
this.patientid = this.$store.state.userInfo.id;


this.addressType=this.$route.query.addressType;

this.getAddress();
this.getOrderDetails();
},
goEvaluate(e){
if(e.isComment==2){
this.$router.push({path:'/judgement',query:{id:e.id}});
}else{
this.$toastMsg("请勿重复评论");
return;
}

},
goChat(e){
console.log(e);
this.$store.state.AllOfValue.ImDoctorInfo={
doctorId:this.doctor.doctorId,
doctorName:this.doctor.doctorName,
inquiryPatientId:e.patientId,
inquiryPatientName:e.patientname,
isOrder:this.doctor.isOrder,
otime:e.buytime,
orderid:e.reOrderprescriptioninfo[0].orderId,
};
this.$store.state.AllOfValue.doctorId = this.doctor.doctorId;
this.$store.state.tabIndex= 'immsg';
this.$router.push({ path: "/im" });
},
checkIsFromMiniProgram: function(callback) {
wx.miniProgram.getEnv(function(res) {
console.log("minprogram:" + res.miniprogram); 

if (res.miniprogram === true) {
callback && callback(true);

} else {
callback && callback(false);

}
});
},
navigateToMiniProgram: function(payParam) {
const url =
"/pages/wxPay/wxPay?payParam=" + encodeURIComponent(payParam);

wx.miniProgram.navigateTo({
url: url
});
},
},

created: function(){
let _this=this;
console.log(_this.$store.state.typeApp)
this.orederId = this.$route.query.id;
this.$isLogin(window.location.search.substr(1),this.init);
document.title = '订单详情';
this.checkIsFromMiniProgram(function(res){
_this.isMiniProgram = res;
})
},
components: {
CheckIcon
}
}



// WEBPACK FOOTER //
// ./src/views/myOrderDetailsYF/index.vue